import { Routes, Route } from "react-router-dom";
import Button from '../../components/button';
import logo from "../../assets/icons/logo.svg";
import menu from "../../assets/icons/menu.svg";
import { useState } from 'react';
import SidebarItems from "./reuseables/sidebarItems";
import Dashboard from "./dashboard";
import SupportCampaign from "./supportCampaign";
import Profile from "./profile";
import add from "../../assets/icons/whiteAddCampaignIcon.svg";
import AllUserCampaign from "./userCampaign/allUsercampaign";
import UserCampaignDetail from "./userCampaign/userCampaignDetail";
import { useSelector } from "react-redux";
import SignOut from "../authentication/signOut";
import CreateCampaign from "./createCampaign/createCampaign";
import AuthenticatedErrorPage from "../errorPages/authenticatedErrorPage";
import close from "../../assets/icons/close.svg";


const UserDashboard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [pageTitle, setPageTitle] = useState("");

  const toggleMenu = () => {
    setIsVisible(!isVisible);
  };

  const userSessionData = useSelector((state) => state.user.userSession);
  if (!userSessionData) {
    return <SignOut />;
  }

  return (
    <div className="bg-backgroundColor">
      <div className="bg-white py-4 md:py-3 px-4 md:px-8 border-b flex justify-between items-center fixed top-0 w-full z-50">
          <div className='flex gap-3 items-center py-3 md:py-0'>
            <div onClick={toggleMenu} className="border p-[6px] rounded lg:hidden">
              <img src={menu} alt="" className="h-4"/>
            </div>
            <div className="pt-[5px]">
              <img src={logo} alt="" className="h-4" />
            </div>
          </div>
          <div className='hidden md:block'>
            <Button
              buttonText={"Create a campaign"}
              buttonRole={"link"}
              destination={"/dashboard/start-a-campaign"}
              otherStyles={"bg-black text-white"}
              icon={add}
            />
          </div>
      </div>
      <div className="px-4 md:px-8 grid lg:flex gap-8">
      <div className="w-full min-h-screen lg:w-1/6 lg:border-r pt-28 md:pt-24 hidden lg:block">
        <SidebarItems pageTitle={pageTitle} />
      </div>
        <div className="w-full lg:w-5/6 pt-28 md:pt-24 pb-10">
        <Routes>
          <Route index element={<Dashboard setPageTitle={setPageTitle}/>} />
          <Route path="support-a-campaign" element={<SupportCampaign setPageTitle={setPageTitle}/>} />
          <Route path="profile" element={<Profile setPageTitle={setPageTitle} />} />
          <Route path="user-campaigns" element={<AllUserCampaign setPageTitle={setPageTitle} />} />
          <Route path="user-campaign-detail/:campaignReference" element={<UserCampaignDetail setPageTitle={setPageTitle} />} />
          <Route path="start-a-campaign" element={<CreateCampaign setPageTitle={setPageTitle} />} />
          <Route path="sign-out" element={<SignOut />} />
          <Route path="*" element={<AuthenticatedErrorPage />} />
        </Routes>
      </div>
      </div>
      {/* small screen menu */}
      {isVisible && (
        <div className="bg-black/80 fixed top-0 z-50 w-full min-h-screen transition-all duration-300 flex lg:hidden">
          <div className="p-4 md:p-8 bg-white rounded-md border border-[#c4c4c424] w-full max-h-[90%] m-4">
            <div className="grid">
              <div className="flex justify-end">
                <span
                  className="border border-lightPrimary rounded p-2 cursor-pointer"
                  onClick={toggleMenu}
                >
                  <img src={close}  alt="" className="h-4"/>
                </span>
              </div>
              <div className="grid mb-4 md:mb-0">
                <SidebarItems pageTitle={pageTitle} closeMenu={toggleMenu} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDashboard;
